import React from 'react';
import Button from 'react-bootstrap/Button'

// Images
import brandedSurveyLogo from './images/branded-survey-logo.png';
import surveyJunkieLogo from './images/survey-junkie-logo.png';
import surveyTimeLogo from './images/survey-time-logo.png';
import signatureSurveyLogo from './images/signature-survey-logo.png';
import eSurveyBoxLogo from './images/esurveybox-logo.jpg';

export default class ThankYou extends React.Component {
  render() {
    return (
      <div className="body">
        <div className="banner-panel banner-small">
          <div className="banner-overlay">
            <div className="gradient"></div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="row pb-5 pt-5">
                <div className="col">
                  <h1 className="gradient-text no-hover mb-4 d-block">Top Paid Surveys</h1>
                  <p><strong>IT ISN'T TOO GOOD TO BE</strong> true. There are paid online survey sites where you can earn extra money. Some of them are even reputable.</p>
                  <p>But is it easy cash? Will you be able to buy your own island soon? No and no.</p>
                  <p>Some of them may be worth your time, however, if you keep a few rules in mind:</p>
                  <ol>
                    <li><strong>Never pay to use an online survey site.</strong> You're the one who is supposed to get paid. If you have to spend any money to join these sites, something is wrong, and you are probably being scammed. Shopping at a retailer through these sites is obviously fine; you're buying stuff.</li>
                    <li><strong>Don't use paid online survey sites as a side job in which you'll depend on the income. </strong>There are better side gigs out there. It's best if you get some enjoyment by trying to score good deals and earn extra cash – but you don't mind if you end up spending a few minutes filling out a survey, only to be told you don't qualify because you fall into the wrong demographic.</li>
                    <li><strong>You usually won't be paid quickly. </strong>Also, filling out a survey sounds like something that will take just a few minutes. Don't be fooled. Sometimes, the surveys can take as long as 15 or 20 minutes.</li>
                  </ol>
                </div>
              </div>

              {/* Branded Survey */}
              <div className="row pt-3">
                <div className="col-md-8">
                  <h3 className="gradient-text no-hover mb-4 d-block">1. Branded Survey</h3>
                </div>
              </div>
              <div className="row align-items-center pb-3">
                <div className="col-md-8">
                  <p>You can sign up or join <a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/ec064f98-0817-492a-a468-6fc22111ee1a?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">BrandedSurveys</a> through Facebook, Google or email. You create a profile and answer a few questions about your life. The more personal information you give, the more the company knows about you (you really shouldn't use any of these sites unless you're OK with companies knowing some things about you) and so they can offer surveys tailored to your interests or lifestyle.</p>
                  <p>You earn points from doing surveys, and the points are redeemed for cash.</p>
                  <p>The average payout is up to (note the "up to") 300 points per survey. According to <a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/ec064f98-0817-492a-a468-6fc22111ee1a?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">BrandedSurveys</a>, 100 points is equal to $1. You're paid via PayPal or gift cards, and you can cash out once you hit $10.</p>
                </div>
                <div className="col-md-4 text-center py-3">
                  <a href="https://7bjse.bemobtrcks.com/go/ec064f98-0817-492a-a468-6fc22111ee1a?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">
                    <img className="mt-md-0 img-fluid" src={brandedSurveyLogo}/>
                  </a>
                </div>
              </div>
              <div className="row pb-5">
                <div className="col-md-3">
                  <Button size="sm" href="https://7bjse.bemobtrcks.com/go/ec064f98-0817-492a-a468-6fc22111ee1a?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition" >Visit site</Button>
                </div>
              </div>

              {/* Survey Junkie */}
              <div className="row pt-3">
                <div className="col-md-8">
                  <h3 className="gradient-text no-hover mb-4 d-block">2. Survey Junkie</h3>
                </div>
              </div>
              <div className="row align-items-center pb-3">
                <div className="col-md-8">
                  <p><a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/0e7e3fe6-2fbd-4295-968c-e9b34cf38f2d?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">SurveyJunkie</a>  is a smaller survey aggregator, but it stands out. The site has a clean, easy-to-use dashboard and offers a high point value for each survey you complete.</p>
                  <p>The point system is direct and shows you how much your points are worth in dollars right on the dashboard. But you have to get to 1,000 points, equal to $10, before you can cash out.</p>
                  <p>Check out our <a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/0e7e3fe6-2fbd-4295-968c-e9b34cf38f2d?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">SurveyJunkie</a> review for more information.</p>
                </div>
                <div className="col-md-4 text-center py-3">
                  <a href="https://7bjse.bemobtrcks.com/go/0e7e3fe6-2fbd-4295-968c-e9b34cf38f2d?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">
                    <img className="mt-md-0 img-fluid" src={surveyJunkieLogo}/>
                  </a>
                </div>
              </div>
              <div className="row pb-5">
                <div className="col-md-3">
                  <Button size="sm" href="https://7bjse.bemobtrcks.com/go/0e7e3fe6-2fbd-4295-968c-e9b34cf38f2d?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition" >Visit site</Button>
                </div>
              </div>

              {/* Survey Time */}
              <div className="row pt-3">
                <div className="col-md-8">
                  <h3 className="gradient-text no-hover mb-4 d-block">3. Survey Time</h3>
                </div>
              </div>
              <div className="row align-items-center pb-3">
                <div className="col-md-8">
                  <p><a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/ea3fd324-400d-4aeb-b04c-1b16519ad9b8?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">SurveyTime</a> is the only survey panel that offers users instant paid surveys with truly instant rewards.</p>
                  <p>With <a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/ea3fd324-400d-4aeb-b04c-1b16519ad9b8?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">SurveyTime</a>, there are no complicated points systems to figure out. Every time you complete a survey, you will receive an instant $1 reward of your choosing (from the rewards options available), sent immediately to your e-mail. There is no waiting for points approvals or for payment - everything is instant!</p>
                  <p>When you've successfully finished completing a survey, you'll be asked how you want to receive your reward. Choose from the options available and receive your reward instantly (within a few minutes or a few hours).</p>
                </div>
                <div className="col-md-4 text-center py-3">
                  <a href="https://7bjse.bemobtrcks.com/go/ea3fd324-400d-4aeb-b04c-1b16519ad9b8?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">
                    <img className="mt-md-0 img-fluid" src={surveyTimeLogo}/>
                  </a>
                </div>
              </div>
              <div className="row pb-5">
                <div className="col-md-3">
                  <Button size="sm" href="https://7bjse.bemobtrcks.com/go/ea3fd324-400d-4aeb-b04c-1b16519ad9b8?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition" >Visit site</Button>
                </div>
              </div>

              {/* eSurvey Box */}
              <div className="row pt-3">
                <div className="col-md-8">
                  <h3 className="gradient-text no-hover mb-4 d-block">4. e-Survey Box</h3>
                </div>
              </div>
              <div className="row align-items-center pb-3">
                <div className="col-md-8">
                  <p><a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/b6622670-0f85-426e-b814-a552cf4e374b?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">eSurveyBox</a> is a free-to-join paid online community panel. By becoming an active member of our community, you'll have the opportunity to give your opinions by answering our online surveys </p>
                  <p>Joining <a className="gradient-text" href="https://7bjse.bemobtrcks.com/go/b6622670-0f85-426e-b814-a552cf4e374b?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">eSurveyBox</a> is simple and free. Fill out the registration form, confirm your membership via email, and start earning rewards by sharing your opinions through our surveys.</p>
                  <p>Redeem your points for eGift cards to your favorite retailers like Amazon and Walmart.</p>
                </div>
                <div className="col-md-4 text-center py-3">
                  <a href="https://7bjse.bemobtrcks.com/go/b6622670-0f85-426e-b814-a552cf4e374b?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition">
                    <img className="mt-md-0 img-fluid" src={eSurveyBoxLogo}/>
                  </a>
                </div>
              </div>
              <div className="row pb-5">
                <div className="col-md-3">
                  <Button size="sm" href="https://7bjse.bemobtrcks.com/go/b6622670-0f85-426e-b814-a552cf4e374b?adv_id=creative&keyword=keyword&place_id=placement&adposition=adposition" >Visit site</Button>
                </div>
              </div>

              {/* Signature Survey */}
              <div className="row pt-3">
                <div className="col-md-8">
                  <h3 className="gradient-text no-hover mb-4 d-block">5. Signature Survey</h3>
                </div>
              </div>
              <div className="row align-items-center pb-3">
                <div className="col-md-8">
                  <p><a className="gradient-text" href="https://c.affcpatrack.com/?aff_id=14246&offer_id=13992">Signature Survey</a>  is free, and the website will never charge you a fee to make money. It’s easy and effortless, so anyone can do it, even if they have no prior knowledge of surveys or online marketing.</p>
                  <p>Receiving your money is easy, as you can log into your account and press the cash-out option. You can either receive your money via check or PayPal. PayPal payments take about 48 hours to be fully processed.</p>
                  <p>When you join, the website promises to give you an activation bonus of $5 and a $20 bonus to get you started. All you have to do is to register your email, and you’ll immediately become a member.</p>
                </div>
                <div className="col-md-4 text-center py-3">
                  <a href="https://c.affcpatrack.com/?aff_id=14246&offer_id=13992">
                    <img className="mt-md-0 img-fluid" src={signatureSurveyLogo}/>
                  </a>
                </div>
              </div>
              <div className="row pb-5">
                <div className="col-md-3">
                  <Button size="sm" href="https://c.affcpatrack.com/?aff_id=14246&offer_id=13992" >Visit site</Button>
                </div>
              </div>
              


              
              
            </div>
          </div>
        </div>
        <div className="footer text-center">
          <div className="container">
            <div className="row">
            </div>
            <div className="row">
              <div className="col-12 copyright">
                <ul>
                  <li><a href="">Terms &amp; Conditions</a></li>
                  <li><a href="">Privacy Policy</a></li>
                </ul>
                <p>© 2021 Kensto</p>
                <p>*Based on <a className="text-underline" href="">possible earnings</a>. These differ due to panelist demographics and survey companies selected, results vary per person.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}